export default __webpack_public_path__ + "static/media/IBMPlexSans-ExtraLightItalic-Latin1.a9e854a0.woff2";